// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --footer-background-colour: #333333;
  --footer-link-colour: #fff;
  --nav-bar-background-colour: #fff;
  --product-content-padding: 0 10px;
}

.footer {
  position: relative;
  overflow: hidden;
}
.footer-branding {
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #000045;
  cursor: pointer;
  white-space: nowrap;
  justify-content: center;
  height: 32px;
}
.footer-branding-img {
  max-height: 46px;
  margin: 2px -13px 0;
  margin-bottom: 3px;
}
.footer-branding-text {
  font-size: 12px;
  font-weight: 600;
}
.footer-legal-links {
  height: 100%;
  display: flex;
  align-items: center;
}
.footer-legal-links-item {
  margin-bottom: -1px !important;
  font-size: 13px;
  cursor: pointer;
  color: #000045;
  padding: 0 3px;
  white-space: nowrap;
  text-decoration: none;
}
.footer-legal-links-item:hover {
  text-decoration: underline;
}

section.footer.flex-column.flex-center {
  background-color: var(--footer-background-colour);
}

section.footer.flex-column.flex-center ul {
  list-style: none;
  padding: 0;
}

.footer-legal-links-item.alternate {
  color: var(--footer-link-colour);
}

section.footer.flex-column.flex-center li {
  margin-bottom: 5px;
  height: 38px;
  display: flex;
  align-items: center;
}

section.footer.flex-column.flex-center .flex-row.no-wrap {
  padding: 20px;
}

.footer-powered-by {
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.stripe-banner {
  max-width: 435px;
}
.stripe-banner img {
  width: 100%;
  background-color: #fff;
  margin: 0;
  border-radius: 5px;
}

.social-media .badges {
  gap: 20px;
  justify-content: center;
  margin-bottom: 20px;
}
.social-media .badges img {
  max-height: 40px;
}
.social-media .links {
  gap: 15px;
  margin-bottom: 15px;
}
.social-media .links img {
  max-width: 32px;
  max-height: 32px;
}

@media screen and (max-width: 479px) {
  .footer {
    font-size: 12px;
    flex-direction: column-reverse;
    align-items: center;
  }
  .footer-legal-links {
    height: unset;
    padding-top: 5px;
  }
  .footer-legal-links span {
    display: block;
  }
  .footer-branding {
    padding: 0;
    margin-top: -1px;
  }
  .footer-branding-img {
    margin-right: -13px;
  }
  .footer-powered-by {
    flex-direction: column;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
